import SHA512 from 'crypto-js/sha512';
import { LDContext } from 'launchdarkly-node-server-sdk';

export enum FeatureFlag {
  invoiceOcr = 'cbo-invoice-ocr',
  darkMode = 'cbo-dark-mode',
  vendorUpload = 'cbo-invoice-vendor-upload',
  labor = 'cbo-labor',
  laborRules = 'cbo-labor-rules',
  generalLedgerAccounts = 'cbo-general-ledger-accounts',
  schedule = 'cbo-schedule',
  schedulingManagerForecastDashboard = 'cbo-scheduling-manager-forecast-dashboard',
  siteTags = 'cbo-site-tags',
  asmCore = 'cbo-asm-core',
  timezoneReports = 'cbo-timezoned-reports',
  houseAccounts = 'cbo-house-accounts',
  laborPayroll = 'cbo-labor-payroll',
  siteGroups = 'cbo-site-groups',
  laborReports = 'cbo-labor-reports',
  scheduleButtons = 'schedule-buttons',
  customMainDashboard = 'cbo-custom-main-dashboard',
  configurableNetGrossSales = 'cbo-configurable-net-and-gross-sales',
  usePackageSelection = 'cbo-package-selection',
  starterPackage = 'cbo-package-starter',
  corePackageScheduling = 'cbo-package-core-scheduling',
  corePackageInventory = 'cbo-package-core-inventory',
  corePackageAdvancedAnalytics = 'cbo-package-core-advanced-analytics',
  corePackageLaborAndPayroll = 'cbo-package-core-labor-payroll',
  laborCopySchedule = 'cbo-labor-copy-schedule',
  cashOffice = 'cbo-cash-office',
  laborTipReports = 'cbo-labor-tip-reports',
  employeeLink = 'cbo-employee-link',
  laborForecastLink = 'cbo-labor-forecast-sales-link',
  laborGuestCheckLink = 'cbo-labor-guest-check-link',
  journalEntry = 'cbo-journal-entry',
  workWeekConfig = 'cbo-work-week-config',
  createEmpOnboarding = 'cbo-create-employee-onboarding',
  restaurantsUiKit = 'cbo-restaurants-ui-kit',
  laborEventsTab = 'cbo-hide-labor-events-tab-pos-event-log',
  hideAlohaEssentialOrgs = 'cbo-hide-aloha-essentials-orgs',
  mobileInventory = 'cbo-mobile-inventory',
  recipe = 'cbo-asm-recipe',
  centralizedReports = 'cbo-centralized-reports',
  laborRulesTipsWages = 'cbo-labor-rules-tips-wages',
  cogs = 'cbo-cogs',
}

export const createContext = (environment: string, nepOrganization: string) => {
  const key = `asm-${nepOrganization}`;

  const context: LDContext = {
    'kind': 'asm-org',
    environment,
    'key': SHA512(key).toString(),
    'nep-organization': nepOrganization,
  };

  return { ...context };
};
